
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.collection-slick__slider');

  if (slider && typeof jQuery !== 'undefined') {
    jQuery(slider).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: `
        <button class="slick-prev custom-arrow" aria-label="Previous">
          <img src="https://cdn.shopify.com/s/files/1/0259/6408/5332/files/Vector_1.png?v=1770375855" alt="Previous">
        </button>
      `,
      nextArrow: `
        <button class="slick-next custom-arrow" aria-label="Next">
          <img src="https://cdn.shopify.com/s/files/1/0259/6408/5332/files/Vector.png?v=1770375855" alt="Next">
        </button>
      `,
      appendArrows: jQuery('.collection-slick__arrows'),
      responsive: [
        {
          breakpoint: 990,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 749,
          settings: { slidesToShow: 1 }
        }
      ]
    });
  }
});

  jQuery(document).ready(function () {
    jQuery('.home-collection__slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: jQuery('.home-collection .swiper-button-prev'),
      nextArrow: jQuery('.home-collection .swiper-button-next'),
      dots: false,
      infinite: false,
      speed: 400,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });



jQuery(document).ready(function(){
  jQuery('.testimonials-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: true,
        prevArrow: '<button class="testimonial-prev"><img src="https://cdn.shopify.com/s/files/1/0259/6408/5332/files/Vector_1.png?v=1770375855" alt="Previous"></button>',
    nextArrow: '<button class="testimonial-next"><img src="https://cdn.shopify.com/s/files/1/0259/6408/5332/files/Vector.png?v=1770375855" alt="Next"></button>',

    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  });

  jQuery('.template-page-styled-for-real-life ul.product-grid').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: true,
        prevArrow: '<button class="testimonial-prev"><img src="https://cdn.shopify.com/s/files/1/0259/6408/5332/files/Vector_1.png?v=1770375855" alt="Previous"></button>',
    nextArrow: '<button class="testimonial-next"><img src="https://cdn.shopify.com/s/files/1/0259/6408/5332/files/Vector.png?v=1770375855" alt="Next"></button>',

    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  });
   
});


jQuery(document).ready(function(){
  jQuery('.title-slider').slick({
      speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  
});




document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-link");
  const panels = document.querySelectorAll(".tab-panel");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      tabs.forEach(t => t.classList.remove("active"));
      panels.forEach(p => p.classList.remove("active"));

      this.classList.add("active");
      document.getElementById(this.dataset.tab).classList.add("active");
    });
  });
});


function moveCustomElement() {
    $('ul.product-grid li').each(function () {
      const $slide = $(this);
      const $cardInner = $slide.find('.card__inner').first();
      const $customMove = $slide.find('.custom-move').first();

      if ($cardInner.length && $customMove.length && !$customMove.parent().is($cardInner)) {
        $customMove.appendTo($cardInner);
      }
    });
  }

  // Run every 5 seconds
  setInterval(function () {
    moveCustomElement();
  }, 500);